import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Sporten tijdens en na zwangerschap</title>
                <link rel="canonical" href={route("blogs.fourteenth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Tijdens de zwangerschap verandert er veel in het lichaam van een vrouw. Dit heeft ook invloed op het sporten. Veel vrouwen vragen zich af wat ze nog kunnen of mogen doen tijdens en na de zwangerschap qua sporten. Er zijn namelijk zeker mogelijkheden om te blijven sporten, maar het is wel belangrijk dat je hier goed mee om gaat."
                />
                <meta
                    property="og:description"
                    content="Tijdens de zwangerschap verandert er veel in het lichaam van een vrouw. Dit heeft ook invloed op het sporten. Veel vrouwen vragen zich af wat ze nog kunnen of mogen doen tijdens en na de zwangerschap qua sporten. Er zijn namelijk zeker mogelijkheden om te blijven sporten, maar het is wel belangrijk dat je hier goed mee om gaat."
                />
                <meta property="og:url" content={route("blogs.fourteenth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Sporten tijdens en na zwangerschap - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/zwangerschap.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/zwangerschap.webp"
                                    type="image/webp"
                                    alt="Zwangerschap"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/zwangerschap.jpg"
                                    type="image/jpeg"
                                    alt="Zwangerschap"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/zwangerschap.jpg"
                                    alt="Zwangerschap"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Sporten tijdens en na een zwangerschap
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Tijdens de zwangerschap verandert er veel in het lichaam
                        van een vrouw. Dit heeft ook invloed op het sporten.
                        Veel vrouwen vragen zich af wat ze nog kunnen of mogen
                        doen tijdens en na de zwangerschap qua sporten. Er zijn
                        namelijk zeker mogelijkheden om te blijven sporten, maar
                        het is wel belangrijk dat je hier goed mee om gaat.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Sporten tijdens de zwangerschap
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Tijdens de zwangerschap zijn er bepaalde sporten die je
                        als vrouw moet vermijden. Dit gaat met name om contact-
                        en balsporten zoals voetbal, handbal, basketbal of
                        volleybal. Dit om te voorkomen dat je per ongeluk een
                        stomp in je buik krijgt.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn echter voldoende alternatieven om actief bezig
                        te blijven tijdens de zwangerschap zonder hierbij dit
                        risico te lopen. Zo kun je nog steeds gaan wandelen,
                        zwemmen, fietsen en zelfs fitness blijven doen.
                        Krachttraining word aangeraden omdat dit ervoor zorgt
                        dat je lichaam sterk wordt en blijft tijdens de
                        zwangerschap en bevalling. Je draagt tijdens deze
                        periode natuurlijk extra gewicht mee. Hiervoor moeten de
                        spieren extra getraind worden zodat je zo min mogelijk
                        last gaat krijgen. Sporten heeft tijdens de zwangerschap
                        namelijk lichamelijke voordelen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Noors onderzoek in 2015 laat zien dat vrouwen die drie
                        keer per week redelijk intensief sporten 14% minder kans
                        hebben op het krijgen van bekkenpijn. Maar ook het
                        risico op klachten als hoge bloeddruk,
                        zwangerschapsdiabetes en vermoeidheid zijn veel minder
                        als je regelmatig sport als je zwanger bent.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Verder bleek uit een onderzoek van de Technische
                        Universiteit van Madrid dat vrouwen die licht intensief
                        blijven sporten tijdens de zwangerschap een minder lange
                        bevalling hebben. Zowel de ontsluitingsfase als de
                        geboorte duurde significant minder lang. Ook bleken deze
                        vrouwen minder last te hebben van pijn tijdens de
                        bevalling. Zij hadden aanzienlijk minder pijnbestrijding
                        nodig dan de vrouwen die niet hadden gesport tijdens de
                        zwangerschap.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn nog wel een aantal dingen waar je rekening me
                        moet houden. Zo moet je bij fitness het trainen van de
                        rechte buikspieren vermijden. Dit verhoogt namelijk de
                        diastase waardoor je extra klachten kunt krijgen van je
                        buikspieren. Daarnaast is het ook van belang om je
                        lichaamstemperatuur niet teveel op te laten lopen
                        tijdens het sporten. Zorg ervoor dat je redelijk
                        luchtige kleding draagt en je traint in een ruimte waar
                        het niet te warm is. Als je merkt dat je zeer vermoeid
                        en het heel warm krijgt neem dan op tijd rust. Ook moet
                        je gedurende de zwangerschap opletten met rennen en
                        springen. Er zijn genoeg voorbeelden van vrouwen die
                        gedurende de zwangerschap kunnen blijven rennen zonder
                        last te krijgen, maar dat is niet bij iedereen het
                        geval. Als je last krijgt van je bekken haal dan
                        oefeningen waarbij je moet rennen en springen uit je
                        schema. Als laatste is het drinken van voldoende water
                        tijdens het trainen ook belangrijk.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Uiteindelijk is het belangrijkste bij het sporten
                        tijdens de zwangerschap om goed te blijven luisteren
                        naar je lichaam. Je mag niet te intensief sporten, wat
                        neerkomt op ongeveer 70% van de normale intensiteit. Als
                        je extra klachten ervaart zoals vermoeidheid of
                        bekkenklachten pas dan je training aan. Zorg ervoor dat
                        je een geschikte trainer zoekt die jou tijdens deze
                        periode op de juiste manier kan begeleiden.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Sporten na de zwangerschap
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Na de bevalling mag je nog niet per direct het sporten
                        oppakken. Bij een vaginale bevalling mag je na 6 weken
                        het sporten weer langzaam gaan opbouwen. Bij een
                        keizersnede word aangeraden minstens 8 weken rust te
                        houden na de bevalling alvorens weer te gaan sporten.
                        Dit betekent niet dat je meteen weer zomaar alles mag
                        doen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn een aantal sporten die je nog beter kunt
                        vermijden. Zo word zwemmen afgeraden zolang je nog
                        bloedverlies ervaart. Dit om mogelijke infecties te
                        voorkomen. Ook fietsen moet je nog mee opletten. Dit mag
                        je weer oppakken zodra je comfortabel op de zadel kunt
                        zitten om te voorkomen dat je mogelijke littekens
                        oploopt. Oefeningen waarbij je moet rennen of springen
                        moet je ook vermijden vanwege mogelijke permanente
                        schade aan je bekkenbodem. Na een half jaar mag je weer
                        voorzichtig oefeningen met rennen en springen gaan
                        toevoegen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Zodra je na de 6 weken het sporten weer oppakt kun je
                        het beste met wat lagere gewichten starten. Deze kun je
                        dan verhogen zolang het comfortabel blijft voelen voor
                        je lichaam. Een zwangerschap en bevalling is een flinke
                        belasting geweest voor het lichaam dus forceer nog niet
                        te veel. Neem de tijd om het lichaam weer op niveau te
                        laten komen. Zorg ook tijdens deze fase dat je de juiste
                        trainer hebt die jou op de juiste manier kan begeleiden.
                        Zo kun je op een goede en veilige manier weer opbouwen
                        naar je oude niveau.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
